export default {
  SET_STATE: "user/SET_STATE",
  GET_USER: "user/GET_USER",
  GET_USER_MUSICS: "user/GET_USER_MUSICS",
  GET_ALL_ACHIEVEMENTS: "user/GET_ALL_ACHIEVEMENTS",
};


export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const SIGNOUT_ERROR = "SIGNOUT_ERROR";